import { Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { Telefone } from 'components/label'

interface ContactSectionProps {
  telefoneResidencial: string
  telefoneCelular: string
  telefoneContato: string
  email: string
}

export const ContatosSection = (props: ContactSectionProps) => {
  const { telefoneResidencial, telefoneCelular, telefoneContato, email } = props

  return (
    <HeadingSection level={2} title='Contatos'>
      <Grid wrap>
        <Cell size={4}>
          <InfoLabel title='Telefone celular'>
            <Telefone value={telefoneCelular} />
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Telefone residencial'>
            <Telefone value={telefoneResidencial} />
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='Telefone de contato'>
            <Telefone value={telefoneContato} />
          </InfoLabel>
        </Cell>
        <Cell size={4}>
          <InfoLabel title='E-mail'>{email}</InfoLabel>
        </Cell>
      </Grid>
    </HeadingSection>
  )
}
